import React, { useState, useMemo } from "react";
import api from "../../../../services/api";
import { fmtNum } from "../../../../shared/utils";
import { sourceImage } from "../../../../utils/source-image";
export default function CadastroEstudo(props) {
  let activities = props.activities;
  let currentStudent = props.currentStudent;
  let setCheckpoints = props.setCheckpoints;
  let checkpoints = props.checkpoints;
  let showFlash = props.showFlash;
  let goto = props.goto;
  const [obs, setObs] = useState("");
  const [foto, setFoto] = useState(null);
  const [arquivo, setArquivo] = useState(null);
  const [itensList, setItensList] = useState([]);
  const [tipoSel, setTipoSel] = useState(0);
  const [qtdSel, setQtdSel] = useState("");
  const [enviando, setEnviando] = useState(false);
  const tiposAtivos = activities
    .filter((activity) => activity.ativo && !activity.automatica)
    .sort((left, right) => left.ordem - right.ordem);
  const tipoAtual = activities.find(
    (activity) => activity.id === Number(tipoSel),
  );
  const qtd = parseFloat(String(qtdSel).replace(",", ".")) || 0;
  const usoHistoricoTipo = useMemo(() => {
    if (
      !tipoAtual ||
      null === currentStudent ||
      undefined === currentStudent ||
      !currentStudent.id
    )
      return {
        pts: 0,
        tok: 0,
      };
    const hoje = new Date().toISOString().slice(0, 10);
    const mesAtual = hoje.slice(0, 7);
    const periodo = "mes" === (tipoAtual.periodo || "dia") ? "mes" : "dia";
    return checkpoints.reduce(
      (acc, checkpoint) => {
        if (Number(checkpoint.aluno_id) !== Number(currentStudent.id))
          return acc;
        if ("invalido" === checkpoint.status_questao) return acc;
        const dataEstudo = String(checkpoint.data_estudo || "");
        if (!dataEstudo) return acc;
        if (
          !("mes" === periodo
            ? dataEstudo.startsWith(mesAtual)
            : dataEstudo === hoje)
        )
          return acc;
        (Array.isArray(checkpoint.itens) ? checkpoint.itens : []).forEach(
          (item) => {
            if (Number(item.tipo_id) === Number(tipoAtual.id)) {
              acc.pts += Number(item.pts_rank || 0);
              acc.tok += Number(item.pts_token || 0);
            }
          },
        );
        return acc;
      },
      {
        pts: 0,
        tok: 0,
      },
    );
  }, [tipoAtual, checkpoints, currentStudent]);
  const rankNaLista = itensList
    .filter((itensListTipo_id) => itensListTipo_id.tipo_id === tipoAtual?.id)
    .reduce((accumulator, item) => accumulator + (item.pts_rank || 0), 0);
  const tokensNaLista = itensList
    .filter((itensListTipo_id) => itensListTipo_id.tipo_id === tipoAtual?.id)
    .reduce((accumulator, item) => accumulator + (item.pts_token || 0), 0);
  const maxRankDisponivel =
    null !== tipoAtual && undefined !== tipoAtual && tipoAtual.max_pts
      ? Math.max(0, tipoAtual.max_pts - usoHistoricoTipo.pts - rankNaLista)
      : 1 / 0;
  const maxTokensDisponivel =
    null !== tipoAtual && undefined !== tipoAtual && tipoAtual.max_token
      ? Math.max(0, tipoAtual.max_token - usoHistoricoTipo.tok - tokensNaLista)
      : 1 / 0;
  const ptsPrevRank = tipoAtual
    ? Math.min(
        tipoAtual.ppu_rank * qtd,
        Number.isFinite(maxRankDisponivel) ? maxRankDisponivel : 1 / 0,
      )
    : 0;
  const ptsPrevTok = tipoAtual
    ? Math.min(
        tipoAtual.ppu_token * qtd,
        Number.isFinite(maxTokensDisponivel) ? maxTokensDisponivel : 1 / 0,
      )
    : 0;
  const adicionarItem = () => {
    if (!tipoAtual || qtd <= 0) {
      showFlash("Selecione atividade e quantidade.", "er");
    } else {
      if (tipoAtual.max_token && 0 === maxTokensDisponivel) {
        showFlash(
          "Limite de "
            .concat(tipoAtual.max_token, " tokens/")
            .concat(tipoAtual.periodo, ' atingido para "')
            .concat(tipoAtual.nome, '".'),
          "er",
        );
      } else {
        if (tipoAtual.max_pts && 0 === maxRankDisponivel) {
          showFlash(
            "Limite de "
              .concat(tipoAtual.max_pts, " pontos/")
              .concat(tipoAtual.periodo, ' atingido para "')
              .concat(tipoAtual.nome, '".'),
            "er",
          );
        } else {
          setItensList([
            ...itensList,
            {
              tipo_id: tipoAtual.id,
              quantidade: qtd,
              pts_rank: ptsPrevRank,
              pts_token: ptsPrevTok,
            },
          ]);
          showFlash(
            ""
              .concat(tipoAtual.nome, ": ")
              .concat(fmtNum(qtd, 1), " ")
              .concat(tipoAtual.unidade, "(s) adicionado(s)!"),
          );
          setTipoSel(0);
          setQtdSel("");
        }
      }
    }
  };
  const totalRank = itensList.reduce(
    (accumulator, itensListPts_rank) =>
      accumulator + itensListPts_rank.pts_rank,
    0,
  );
  const totalToken = itensList.reduce(
    (accumulator, itensListPts_token) =>
      accumulator + itensListPts_token.pts_token,
    0,
  );
  return (
    <div>
      <div
        style={{
          fontSize: 12,
          color: "#6B8590",
          marginBottom: 14,
        }}
      >
        {"Registre tudo que estudou hoje em 1 único envio"}
      </div>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          if (enviando) return;
          if (
            null !== currentStudent &&
            undefined !== currentStudent &&
            currentStudent.id
          ) {
            if (obs.trim()) {
              if (0 !== itensList.length) {
                setEnviando(true);
                try {
                  const campos = {
                    aluno_id: currentStudent.id,
                    observacao: obs.trim(),
                    pontos_rank: totalRank,
                    tokens: totalToken,
                    criado_em: Date.now(),
                    itens: JSON.stringify(itensList),
                  };
                  const body = new FormData();
                  Object.entries(campos).forEach((item) => {
                    const [chave, valor] = item;
                    return body.append(chave, valor);
                  });
                  if (arquivo) {
                    body.append("file", arquivo);
                  }
                  const responseData2 = await api.post("/checkpoints", body, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  });
                  const saved = responseData2.data?.data ?? responseData2.data;
                  setCheckpoints((prev) => [saved, ...prev]);
                  showFlash(
                    "Checkpoint registrado! +"
                      .concat(fmtNum(totalRank), " pts rank | +")
                      .concat(fmtNum(totalToken), " tokens"),
                  );
                  goto("feed");
                } catch (err) {
                  showFlash(
                    err.response?.data?.message ||
                      "Nao foi possivel registrar o checkpoint agora.",
                    "er",
                  );
                } finally {
                  setEnviando(false);
                }
              } else showFlash("Adicione pelo menos 1 atividade.", "er");
            } else
              showFlash(
                "Descrição das matérias estudadas é obrigatória.",
                "er",
              );
          } else
            showFlash(
              "Não foi possível identificar o aluno. Tente novamente.",
              "er",
            );
        }}
        className={"fc"}
      >
        <div
          className={"fr"}
          style={{
            marginBottom: 14,
          }}
        >
          <div
            className={"fg"}
            style={{
              marginBottom: 0,
            }}
          >
            <label>
              {"Foto"}
              <span
                style={{
                  background: "#E0F5F0",
                  color: "#1A7A6E",
                  fontSize: 9,
                  fontWeight: 700,
                  borderRadius: 999,
                  padding: "2px 6px",
                  marginLeft: 6,
                }}
              >
                {"OPCIONAL - máx 5MB"}
              </span>
            </label>
            <input
              type={"file"}
              accept={"image/*"}
              className={"inp"}
              onChange={async (event) => {
                const item = event.target.files[0];
                if (!item) return;
                if (item.size > 5242880) {
                  showFlash(
                    "Arquivo muito grande. Máximo: 5MB (seu arquivo: ".concat(
                      fmtNum(item.size / 1024 / 1024, 1),
                      "MB)",
                    ),
                    "er",
                  );
                  return;
                }
                const instance = new FileReader();
                instance.onload = (eventTarget) =>
                  setFoto(eventTarget.target.result);
                instance.readAsDataURL(item);
                setArquivo(item);
              }}
            />
          </div>
        </div>
        {foto && (
          <div
            style={{
              marginBottom: 12,
            }}
          >
            <img
              src={sourceImage(foto)}
              style={{
                maxWidth: "100%",
                maxHeight: 160,
                borderRadius: 9,
                display: "block",
                objectFit: "cover",
              }}
              alt={""}
            />
            <button
              type={"button"}
              className={"btn bg bs"}
              style={{
                marginTop: 6,
              }}
              onClick={() => {
                setFoto(null);
                setArquivo(null);
              }}
            >
              {"Remover"}
            </button>
          </div>
        )}
        <div
          style={{
            background: "#F4F8F9",
            borderRadius: 12,
            padding: "14px 12px",
            marginBottom: 14,
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 800,
              color: "#1F4754",
              marginBottom: 2,
            }}
          >
            {"Adicionar atividade"}
          </div>
          <div
            style={{
              fontSize: 11,
              color: "#6B8590",
              marginBottom: 12,
            }}
          >
            {"Escolha a atividade, informe a quantidade e clique em OK"}
          </div>
          <div className={"fg"}>
            <label>{"Tipo de atividade"}</label>
            <select
              className={"sel"}
              value={tipoSel}
              onChange={(event) => {
                setTipoSel(Number(event.target.value));
                setQtdSel("");
              }}
            >
              <option value={0}>{"Selecione o tipo..."}</option>
              {tiposAtivos.map((tiposAtivo) => (
                <option value={tiposAtivo.id} key={tiposAtivo.id}>
                  {tiposAtivo.nome}
                </option>
              ))}
            </select>
          </div>
          {tipoAtual && (
            <div className={"fg"}>
              <label>
                {"Quantidade de "}
                {tipoAtual.unidade}
                {"s"}
                {tipoAtual.max_token || tipoAtual.max_pts
                  ? " (limites: "
                      .concat(
                        tipoAtual.max_token
                          ? ""
                              .concat(tipoAtual.max_token, " tok/")
                              .concat(tipoAtual.periodo)
                          : "sem limite de token",
                        " | ",
                      )
                      .concat(
                        tipoAtual.max_pts
                          ? ""
                              .concat(tipoAtual.max_pts, " pts/")
                              .concat(tipoAtual.periodo)
                          : "sem limite de pontos",
                        ")",
                      )
                  : ""}
              </label>
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  alignItems: "flex-start",
                }}
              >
                <input
                  type={"number"}
                  step={"0.5"}
                  min={"0.5"}
                  className={"inp"}
                  style={{
                    flex: 1,
                  }}
                  value={qtdSel}
                  onChange={(event) => setQtdSel(event.target.value)}
                  placeholder={"Ex: ".concat(
                    "hora" === tipoAtual.unidade
                      ? "2"
                      : "questao" === tipoAtual.unidade
                        ? "30"
                        : "1",
                  )}
                  onKeyDown={(event) => {
                    if ("Enter" === event.key) {
                      event.preventDefault();
                      adicionarItem();
                    }
                  }}
                />
                <button
                  type={"button"}
                  className={"btn"}
                  style={{
                    padding: "11px 20px",
                    flexShrink: 0,
                    fontSize: 14,
                    fontWeight: 900,
                  }}
                  onClick={adicionarItem}
                >
                  {"OK"}
                </button>
              </div>
              {qtd > 0 && (
                <div
                  style={{
                    marginTop: 7,
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      background: "#FFF1DD",
                      color: "#B8651E",
                      borderRadius: 8,
                      padding: "5px 10px",
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    {"+"}
                    {fmtNum(ptsPrevRank)}
                    {" pts rank"}
                  </span>
                  <span
                    style={{
                      background: "#E0F5F0",
                      color: "#1A7A6E",
                      borderRadius: 8,
                      padding: "5px 10px",
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    {"+"}
                    {fmtNum(ptsPrevTok)}
                    {" tokens"}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
        {itensList.length > 0 && (
          <div
            style={{
              marginBottom: 14,
            }}
          >
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#1F4754",
                marginBottom: 8,
              }}
            >
              {itensList.length}
              {" atividade"}
              {itensList.length > 1 ? "s" : ""} {"adicionada"}
              {itensList.length > 1 ? "s" : ""}
              {":"}
            </div>
            <div className={"al"}>
              {itensList.map((itensListTipo_id, idx) => {
                const tipo = activities.find(
                  (activity) => activity.id === itensListTipo_id.tipo_id,
                );
                return (
                  <div
                    className={"ai"}
                    style={{
                      borderLeftColor: tipo?.cor || "#4FB3A9",
                    }}
                    key={idx}
                  >
                    <div>
                      <div className={"ail"}>{tipo?.nome}</div>
                      <div className={"aiq"}>
                        {fmtNum(itensListTipo_id.quantidade, 1)} {tipo?.unidade}
                        {"s"}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <div className={"aip"}>
                        <div className={"rank"}>
                          {"+"}
                          {fmtNum(itensListTipo_id.pts_rank)}
                          <small>{"Pontos"}</small>
                        </div>
                        <div className={"tok"}>
                          {"+"}
                          {fmtNum(itensListTipo_id.pts_token)}
                          <small>{"Tokens"}</small>
                        </div>
                      </div>
                      <button
                        type={"button"}
                        onClick={() =>
                          ((idxItem) =>
                            setItensList(
                              itensList.filter(
                                (itensListItem, index) => index !== idxItem,
                              ),
                            ))(idx)
                        }
                        style={{
                          background: "none",
                          border: "none",
                          color: "#D9534F",
                          cursor: "pointer",
                          fontSize: 18,
                          padding: "0 4px",
                          lineHeight: 1,
                        }}
                      >
                        {"x"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className={"fg"}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            {"Descrição"}
            <span
              style={{
                background: "#D9534F",
                color: "#FFF",
                fontSize: 9,
                fontWeight: 700,
                borderRadius: 999,
                padding: "2px 6px",
              }}
            >
              {"OBRIGATÓRIO"}
            </span>
          </label>
          <textarea
            className={"tea"}
            value={obs}
            onChange={(event) => setObs(event.target.value)}
            style={{
              minHeight: 80,
              borderColor: obs.trim() ? "#4FB3A9" : "#D5DEE3",
            }}
            placeholder={
              "Descreva as matérias estudadas hoje. Ex: Biologia - Citologia / Matematica - Funcoes do 2 grau / Redacao - Meio ambiente"
            }
          />
          <div
            style={{
              fontSize: 11,
              color: "#6B8590",
              marginTop: 3,
            }}
          >
            {"Seja específico: matéria + tópico"}
          </div>
        </div>
        <div
          style={{
            background:
              itensList.length > 0
                ? "linear-gradient(90deg,#1F4754,#2A5868)"
                : "#F4F8F9",
            borderRadius: 12,
            padding: "14px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 9,
                letterSpacing: ".2em",
                textTransform: "uppercase",
                color:
                  itensList.length > 0 ? "rgba(255,255,255,0.5)" : "#6B8590",
                fontWeight: 600,
              }}
            >
              {"Total"}
            </div>
            <div
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: itensList.length > 0 ? "#FFC76B" : "#B8C5CC",
                lineHeight: 1,
              }}
            >
              {fmtNum(totalRank)}
              <small
                style={{
                  fontSize: 11,
                  marginLeft: 5,
                  fontWeight: 600,
                }}
              >
                {"Pontos"}
              </small>
            </div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: itensList.length > 0 ? "#4FB3A9" : "#B8C5CC",
                marginTop: 2,
              }}
            >
              {fmtNum(totalToken)}
              <small
                style={{
                  fontSize: 10,
                  marginLeft: 4,
                }}
              >
                {"Tokens"}
              </small>
            </div>
          </div>
          <button type={"submit"} className={"btn"} disabled={enviando}>
            {enviando ? "Enviando…" : "Registrar Checkpoint"}
          </button>
        </div>
      </form>
      <div
        style={{
          marginTop: 12,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          type={"button"}
          onClick={() => goto("feed")}
          className={"btn bg bs"}
        >
          {"Cancelar"}
        </button>
      </div>
    </div>
  );
}
